import { render, staticRenderFns } from "./ModalVoirAvisCROP.vue?vue&type=template&id=b2ef0ccc&"
import script from "./ModalVoirAvisCROP.vue?vue&type=script&lang=js&"
export * from "./ModalVoirAvisCROP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports